window.counterScan = function(){
  let buffer = "";
  let buffer_cleaning;

  window.counterScanHandler = function(e){
    if (buffer_cleaning) clearTimeout(buffer_cleaning);
    buffer_cleaning = setTimeout(() => {
      buffer = "";
      console.log("Buffer auto-cleared");
    }, 750);

    if (e.key === "/") {
      e.preventDefault();
    }
    
    if (e.key === "Tab" || e.key === "Enter") {
      e.preventDefault(); 
      console.log("Barcode scanned:", buffer);
      
      const id = $("input[name='id']").val()
      const stage = $("input[name='stage']").val()
      const pc_id = $("#assemblies").attr("pc_id")
      
      $.ajax({
        url: `/dashboard/counters/${id}`,
        method: "PATCH",
        data: {
          stage: stage,
          pc_id: pc_id,
          barcode_value: buffer
        },
        headers: { 'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content') },
        dataType: 'json',
        beforeSend:function(){
          $("#scan-message").html(setSpinner())
        },
        success:function(res) {
          const target = $("#assemblies")
          const keyparts = res.keyparts
          const counter = res.counter
          const product_counter_id = res.product_counter_id
          
          if (product_counter_id) {
            if (buffer != ""){
              $("#counter-product").text(buffer)
            }
            target.attr("pc_id", product_counter_id)
          }

          if (keyparts) {
            console.log(keyparts)
            target.html("")

            keyparts.forEach(function(data, idx){
              $("#assemblies").append(`
                <tr class="${data.scan ? "bg-success" : ""}">
                  <td class='py-1 ${data.scan ? 'text-white' : ''}'>${idx + 1}</td>
                  <td class='py-1 ${data.scan ? 'text-white' : ''}'>${data.part_name}</td>
                  <td class='py-1 ${data.scan ? 'text-white' : ''}'>${data.internal_part_id}</td>
                  <td class='py-1 ${data.scan ? 'text-white' : ''}'>${data.customer_part_number}</td>
                  <td class='py-1 ${data.scan ? 'text-white' : ''}'>${data.qr_value}</td>
                </tr>
              `)
            })
          }

          if (counter) {
            $("#counter-count-gross").text(counter.gross)
            $("#counter-count-ng").text(counter.ng)
            $("#counter-count-ok").text(counter.ok)
            $("#counter-count-planning").text(counter.planning)
            $("#counter-count-actual").text(counter.actual)
            $("#counter-count-percent-target").text(counter.percent_target)
          }

          showToast("success", "", res.message)
          // $("#scan-message").html(`
          //   <p class="text-center px-5 py-3 bg-success rounded text-white">${res.message}</p>
          // `)
          $("#audio-scan-success").get(0).play()
        },
        error: function(jqXHR) {
          showToast("error", "", jqXHR.responseJSON.message)

          // $("#scan-message").html(`
          //   <p class="text-center px-5 py-3 bg-danger rounded text-white">${jqXHR.responseJSON.message}</p>
          // `)
          $("#audio-scan-failed").get(0).play()
        },
        complete: function() {
          buffer = "";
        }
      })
    }

    if (e.key.length === 1) {
      buffer += e.key;
    }
  }

  document.addEventListener("keydown", counterScanHandler);
}

window.counterRegularScan = function(){
  let buffer = "";
  let buffer_cleaning;

  window.counterRegularScanHandler = function(e){
    if (buffer_cleaning) clearTimeout(buffer_cleaning);
    buffer_cleaning = setTimeout(() => {
      buffer = "";
      console.log("Buffer auto-cleared");
    }, 750);
    
    if (e.key === "Tab" || e.key === "Enter") {
      e.preventDefault(); 
      console.log("Barcode scanned:", buffer);
      
      const id = $("input[name='id']").val()
      
      $.ajax({
        url: `/dashboard/counter_regulars/${id}`,
        method: "PATCH",      
        data: {
          internal_label_barcode_value: buffer  
        },
        headers: { 'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content') },
        dataType: 'json',
        beforeSend:function(){
          $("#scan-message").html(setSpinner())
        },
        success:function(res) {
          const counter = res.counter

          if (counter) {
            $("#counter-count-gross").text(counter.gross)
            $("#counter-count-ng").text(counter.ng)
            $("#counter-count-ok").text(counter.ok)
            $("#counter-count-planning").text(counter.planning)
            $("#counter-count-actual").text(counter.actual)
            $("#counter-count-percent-target").text(counter.percent_target)
          }

          $("#scan-message").html(`
            <p class="text-center px-5 py-3 bg-success rounded text-white">${res.message}</p>
          `)
          $("#audio-scan-success").get(0).play()
        },
        error: function(jqXHR) {
          $("#scan-message").html(`
            <p class="text-center px-5 py-3 bg-danger rounded text-white">${jqXHR.responseJSON.message}</p>
          `)
          $("#audio-scan-failed").get(0).play()
        },
        complete: function() {
          buffer = "";
        }
      })
    }

    if (e.key.length === 1) {
      buffer += e.key;
    }
  }

  document.addEventListener("keydown", counterRegularScanHandler);
}

window.materialPreparationScan = function(){
  let buffer = "";
  let buffer_cleaning;

  window.materialPreparationScanHandler = function(e){
    console.log("===")
    if (e.key === " ") {
      console.log("spacexx")
      return
    }

    if (buffer_cleaning) clearTimeout(buffer_cleaning);
    buffer_cleaning = setTimeout(() => {
      buffer = "";
      console.log("Buffer auto-cleared");
    }, 750);

    if (e.key === "Tab" || e.key === "Enter") {
      e.preventDefault(); 
      console.log("Barcode scanned:", buffer);
      
      const id = $("#material_preparation_secproc_planning_product_item_id").val()
      
      $.ajax({
        url: `/second_process/material_preparations/${id}/scan`,
        data: {
          barcode_value: buffer  
        },
        dataType: 'json',
        beforeSend:function(){
          $("#scan-message").html(setSpinner())
        },
        success:function(res) {
          $("#scan-message").html(`
            <p class="text-center px-5 py-3 bg-success rounded text-white">${res.message}</p>
          `)

          const currentRow = $(`tr[customer_pn='${res.data.customer_pn}']`)
          if (currentRow.length) {
            const id = currentRow.attr('assembly_id');

            $("#audio-scan-success").get(0).play()
  
            currentRow.find('td:nth-child(5)').append(
              `<input type="text" name="new_record_item[${id}][lot][]" class="form-control mt-1" value='${res.data.lot}'/>`
            );
  
            currentRow.find('td:nth-child(6)').append(
              `<input type="number" name="new_record_item[${id}][qty][]" class="form-control mt-1"  value='${res.data.qty}'/>`
            );

            showToast("success", "", res.message)
          } else {
            $("#audio-scan-failed").get(0).play()
            showToast("error", "", "Tidak ditemukan!")
          }
        },
        error: function(jqXHR) {
          showToast("error", "", jqXHR.responseJSON.message)
          $("#audio-scan-failed").get(0).play()
        },
        complete: function() {
          buffer = "";
        }
      })
    }

    if (e.key.length === 1) {
      console.log("key")
      buffer += e.key;
    }
  }

  document.addEventListener("keydown", materialPreparationScanHandler);
}

window.combineLabelScan = function(){
  let buffer = "";
  let buffer_cleaning;

  window.combineLabelScanHandler = function(e){
    if (buffer_cleaning) clearTimeout(buffer_cleaning);
    buffer_cleaning = setTimeout(() => {
      buffer = "";
      console.log("Buffer auto-cleared");
    }, 750);
    
    if (e.key === "Tab" || e.key === "Enter") {
      e.preventDefault(); 
      console.log('x')
      console.log("Barcode scanned:", buffer);
      
      const id = $("#combine-label-dom").attr("planning_item_id")
      const url = `/dashboard/combine_labels/${id}`
      $.ajax({
        url: url,
        method: "PATCH",
        data: {
          label_value: buffer  
        },
        headers: { 'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content') },
        dataType: 'json',
        beforeSend: function(){
          $("#combine-label-dom").html(setSpinner())
        },
        success: function(res) {
          showToast("success", "", res.message)
          $("#audio-scan-success").get(0).play()
        },
        error: function(jqXHR) {
          showToast("error", "", jqXHR.responseJSON.message)
          $("#audio-scan-failed").get(0).play()
        },
        complete: function() {
          buffer = "";
          document.removeEventListener("keydown", combineLabelScanHandler);
          $.ajax({
            url: url,
            dataType: 'script',
            success: function(res){
              $('.modal-body').html(res)
            }, 
            error: function(jqXHR){
              showToast("error", "", jqXHR.responseJSON.message)
            }
          })
        }
      })
    }

    if (e.key.length === 1) {
      buffer += e.key;
    }
  }

  document.addEventListener("keydown", combineLabelScanHandler);
}